module.exports = __webpack_public_path__ + "img/grocery.53bbb783.png";